import Phaser from 'phaser';

/** One pixel out each way. */
export const RING_1: readonly (readonly [number, number])[] = [
  [1, 0],
  [-1, 0],
  [0, 1],
  [0, -1],
];
/** Two pixels out each way, one at the corners: a ring round {@link RING_1}. */
export const RING_2: readonly (readonly [number, number])[] = [
  [2, 0],
  [-2, 0],
  [0, 2],
  [0, -2],
  [1, 1],
  [1, -1],
  [-1, 1],
  [-1, -1],
];

/**
 * An outline round a sprite (head to head marks each mower): copies of its texture filled with a
 * flat color, nudged out by a pixel or two, under the sprite. Rings listed first draw lowest, so an
 * outer ring goes first. Call {@link follow} after moving the sprite each frame.
 */
export class SpriteOutline {
  private readonly copies: { sprite: Phaser.GameObjects.Sprite; ox: number; oy: number }[] = [];

  constructor(
    scene: Phaser.Scene,
    texture: string,
    rings: readonly { color: number; offsets: readonly (readonly [number, number])[] }[],
    depth: number,
  ) {
    for (const { color, offsets } of rings) {
      for (const [ox, oy] of offsets) {
        const sprite = scene.add
          .sprite(0, 0, texture, 0)
          .setTint(color)
          .setTintMode(Phaser.TintModes.FILL)
          .setDepth(depth);
        this.copies.push({ sprite, ox, oy });
      }
    }
  }

  /**
   * Matches the sprite's place, frame, see-through and visibility (`shown` false hides it: a
   * see-through mower has none).
   */
  follow(target: Phaser.GameObjects.Sprite, shown = true): void {
    for (const { sprite, ox, oy } of this.copies) {
      sprite
        .setPosition(target.x + ox, target.y + oy)
        .setFrame(target.frame.name)
        .setAlpha(target.alpha)
        .setVisible(target.visible && shown);
    }
  }
}
